import _slicedToArray from"/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";/**
 * A key that changes when the reader asks for the data again.
 *
 * Every console view that reads through a hook needs the same two things: a
 * value to hand `useLazyLoadQuery` as its `fetchKey`, and something for a
 * Refresh button to call. Relay has no "read it again" on the hook itself —
 * the way to ask twice is to pass a different key — so this is the shape that
 * fact takes, in one place rather than in every view that has a Refresh.
 *
 * It is a counter and not a timestamp: two refreshes inside one millisecond
 * are two asks, and a clock would merge them.
 */import{useCallback,useState}from"react";export function useReloadKey(){const _useState=useState(0),_useState2=_slicedToArray(_useState,2),reloads=_useState2[0],setReloads=_useState2[1];const askAgain=useCallback(()=>{setReloads(count=>count+1);},[]);return[reloads,askAgain];}